import { useSpring } from 'react-spring';

interface IArgs {
    stage: string;
    delay?: number;
    onRest?(): void;
}

export function createEnterExitAnimation(config: IArgs) {
    const { stage, delay, onRest } = config;

    return useSpring({
        from: {
            opacity: stage === 'enter' ? 0 : 1,
            transform:
                stage === 'enter' ? 'translateY(100px)' : 'translateY(0px)',
        },
        to: {
            opacity: stage === 'exit' ? 0 : 1,
            transform:
                stage === 'exit' ? 'translateY(-100px)' : 'translateY(0px)',
        },
        delay,
        onRest,
    });
}
